import { isProduction } from '..';
import type { AppConfig } from '../types';

export default {
  zone: 'anz-1',
  defaultLocale: 'en-AU',
  availableLocales: ['en-AU'],
  timedBanners: {
    privatePolicyBanner: {
      privatePolicy: {
        displayDates: {
          startDate: '2023-10-15T00:00:00.000Z',
          endDate: '2023-11-14T23:59:59.000Z',
        },
        type: 'PrivacyPolicy',
      },
    },
  },
  zoneFeatures: {
    COMPANY_PROFILE_CAROUSEL: true,
    QUICK_SEARCH_ENABLED: true,
    LMIS_ENABLED: true,
    NUDGE_ENABLED: true,
    SHOW_HOMEPAGE_BANNER: true,
    HOMEPAGE_BANNER_TYPE: 'SEEKRET_ANZ_BANNER',
    SHOW_FLOATING_SAVE_SEARCH: true,
    SHOULD_OPEN_APPLY_IN_NEW_TAB: true,
    SHOW_JOBCARD_TEASER_IN_SPLITVIEW: true,
    AUTO_SELECT_SPLIT_VIEW_FIRST_JOB: false,
    SHOW_MARKETING_AD_SPLIT_VIEW: true,
    SHOW_STICKY_APPLY_ON_DESKTOP: true,
    SERP_KEYWORD_TEXTFIELD: true,
    SALARY_TRANSPARENCY_ENABLED: false,
  },
  BRANCH_IO_KEY: isProduction
    ? 'key_live_hpVf26efkYxTQTj88NJzZpchsqglHGRe'
    : 'key_test_khOf96nlb9tQIPl47VZiEcbpszklPUNw',
} as AppConfig;
